import { render } from "./OrganizationPage.vue?vue&type=template&id=46220a17&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&lang=js"

import "./OrganizationPage.vue?vue&type=style&index=0&id=46220a17&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46220a17"]])

export default __exports__